import { ProductAttribute } from '@@partner:types:app'
import { GQL_ID } from '@@partner:types:graphql'

import { gql, useQuery } from '@apollo/client'

import { SHORTCUT_PRODUCT_ATTRIBUTE_FIELDS } from '@@partner:graphql/shortcuts'


type Variables = {
  id?: GQL_ID | null
}

type Query = {
  singleProductAttribute: ProductAttribute
}

export const GQL_QUERY_SINGLE_PRODUCT_ATTRIBUTE = gql`
  query singleProductAttribute ($id: ID!) {
    singleProductAttribute(id: $id) {
      ${SHORTCUT_PRODUCT_ATTRIBUTE_FIELDS}
    }
  }
`

export const useFetchSingleProductAttribute = (variables: Variables) => useQuery<Query, Variables>(GQL_QUERY_SINGLE_PRODUCT_ATTRIBUTE, {
  variables,
  skip: !variables.id
})